module.exports = __webpack_public_path__ + "img/restaurant.7872af01.svg";